import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";

const DrugIntakeForm = ({ onSubmit, onCancel }) => {
    const noteRef = useRef();
    const [datetime, setDatetime] = useState(new Date());
    const [dose, setDose] = useState();
    const [initial, setInitial] = useState();

    return (
        <form
            method="POST"
            onSubmit={(e) => {
                e.preventDefault();
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                onSubmit({
                    note: noteRef.current.value,
                    datetime,
                    dose,
                    initial,
                });
            }}
        >
            <div className="form-row m-t-20">
                <div className="col">
                    <label htmlFor="dose-id">Dose *</label>
                    <input
                        type="text"
                        className="form-control input-height"
                        id="dose-id"
                        onChange={({ currentTarget }) => setDose(currentTarget.value)}
                        required
                        aria-describedby="dose-id"
                        placeholder="enter dose"
                    />
                </div>

                <div className="col">
                    <label htmlFor="initial-id">Initial*</label>
                    <input
                        type="text"
                        className="form-control input-height"
                        id="initial-id"
                        onChange={({ currentTarget }) => setInitial(currentTarget.value)}
                        required
                        aria-describedby="initial-id"
                        placeholder="enter initial"
                    />
                </div>
                <div className="col">
                    <label htmlFor="datetime-id">Date and Time of Administration*</label>
                    <DatePicker
                        selected={datetime}
                        onChange={(date) => setDatetime(date)}
                        showTimeSelect
                        timeIntervals={15}
                        timeCaption="Time"
                        timeFormat="HH:mm"
                        id="datetime-id"
                        dateFormat="MMM d, yyyy h:mm aa"
                        className="form-control input-height"
                    />
                </div>
            </div>

            <div className="form-group m-t-20 m-b-20">
                <label htmlFor="note-id">Note (if any)</label>
                <textarea name="note-id" id="note-id" ref={noteRef} className="form-control form-control-textarea" rows="4" placeholder="enter drug note"></textarea>
            </div>

            <div className="form-group text-center m-t-20">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success">
                    Register Intake
                    <i className="material-icons">keyboard_arrow_down</i>
                </button>
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle">
                    Cancel <i className="material-icons text-danger">close</i>
                </button>
            </div>
        </form>
    );
};
export default DrugIntakeForm;
